'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModalServiceController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ModalServiceController = exports.ModalServiceController = function () {
    function ModalServiceController($uibModalInstance, title, message, buttons, onResult) {
        _classCallCheck(this, ModalServiceController);

        this.$uibModalInstance = $uibModalInstance;
        this.Title = title;
        this.Message = message;
        this.Buttons = buttons;
        this.OnResult = onResult;
    }

    _createClass(ModalServiceController, [{
        key: 'Click',
        value: function Click(button) {
            this.OnResult(button.Result);
            this.$uibModalInstance.close();
        }
    }]);

    return ModalServiceController;
}();

ModalServiceController.$inject = ['$uibModalInstance', 'title', 'message', 'buttons', 'onResult'];

_module3.default.controller('ModalServiceController', ModalServiceController);


//////////////////
// WEBPACK FOOTER
// ./src/core/modalService/modalServiceModal.js
// module id = 73
// module chunks = 0 2